import { render } from "./SectionTitleCentury.vue?vue&type=template&id=f15174ba"
import script from "./SectionTitleCentury.vue?vue&type=script&lang=js"
export * from "./SectionTitleCentury.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__